import { getInviteLink } from '@/modules/UIDesign/Invites/functions';
import BaseModel from './base';
import CertificateProfile from './certificate-profile';
import User from '@/utils/user';
import { INVITE_TYPE } from '@/modules/UIDesign/Invites/constants';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';

export const REQUEST_STATUS = {
  outsider: null,
  waiting: 1,
  accept: 2,
  cancelOrganizer: 3,
  cancelExpert: 4,
  awaitingActivation: 5,
};

export const REQUEST_STATUS_DATA = {
  [REQUEST_STATUS.waiting]: {
    id: REQUEST_STATUS.waiting,
    name: 'Ожидает подтверждения',
    attrs: {
      color: 'warning',
    },
    icon: '$iclock-outline',
  },
  [REQUEST_STATUS.accept]: {
    id: REQUEST_STATUS.accept,
    name: 'Управляется экспертом',
    attrs: {
      color: 'redesignSuccess',
    },
    icon: '$icheck',
  },
  [REQUEST_STATUS.cancelExpert]: {
    id: REQUEST_STATUS.cancelExpert,
    name: 'Отменен экспертом',
    attrs: {
      color: 'redesignError',
    },
    icon: '$iclose',
  },
  [REQUEST_STATUS.cancelOrganizer]: {
    id: REQUEST_STATUS.cancelOrganizer,
    name: 'Отменен вами',
    attrs: {
      color: 'redesignError',
    },
    icon: '$iclose',
  },
  [REQUEST_STATUS.awaitingActivation]: {
    id: REQUEST_STATUS.awaitingActivation,
    name: 'Ожидает активации',
    attrs: {
      color: 'warning',
    },
    icon: '$iclock-outline',
  },
  [REQUEST_STATUS.outsider]: {
    id: REQUEST_STATUS.outsider,
    name: 'Внешний эксперт',
    attrs: {
      color: undefined,
    },
    icon: undefined,
  },
};

export default class Expert extends BaseModel {
  #user;

  constructor(expert, url) {
    super(expert, url);

    let organization = [];
    if (Array.isArray(expert?.organization)) {
      organization = expert.organization;
    } else if (expert?.organization) {
      organization = [expert.organization];
    }

    this.profile = new CertificateProfile(expert?.profile || expert || {});
    this.departament = expert?.departament || null;
    this.created_at = expert?.created_at || null;
    this.requests = expert?.requests || [];
    this.roles = expert?.roles || [];
    this.username = expert?.username || '';
    this.nomination_ids = expert?.nomination_ids || [];
    this.timezone = expert?.timezone || null;
    this.invite_code = expert?.invite_code || expert?.invite || null;
    this.organization = organization;
    this.is_global = expert?.is_global || false;
    this.assign = expert?.assign || null;
    this.first_name = expert?.first_name || null;
    this.last_name = expert?.last_name || null;
    this.middle_name = expert?.middle_name || null;
    this.position = expert?.position || this.profile?.caption || null;
    this.is_active = expert?.is_active ?? true;
    this.user = expert?.user || null;
    this.user_id = expert?.user_id || expert?.user?.id || null;
    this.image = expert?.image || null;
    this.avatar = expert?.avatar || null;
    this.expertise_count = expert?.expertise_count || 0;

    this.organizer = null;

    this.#user = new User();
  }

  get isMineExpert() {
    return this.organization.some((item) => item.id === this.#user?.data?.organizer?.id);
  }

  get expertName() {
    return [this.last_name, this.first_name, this.middle_name].filter(Boolean).join(' ');
  }

  get fullName() {
    return this.profile?.name || this.expertName;
  }

  initOrganizerData(organizerId) {
    this.organizer = {
      id: this.isMineExpert ? organizerId : null,
      request: {
        id: null,
        status: this.getOrganizerRequestStatus(),
      },
    };
  }

  getOrganizerRequestStatus() {
    if (!this.user_id) {
      return REQUEST_STATUS_DATA[REQUEST_STATUS.awaitingActivation];
    }

    return null;
  }

  get inviteLink() {
    const getMethod = (methodType) => rHandler(
      apiService?.[methodType]?.(`${this.url}/${this.id}/invite`),
      (response) => ({
        response,
        item: getInviteLink(response?.data?.data?.invite || '', INVITE_TYPE.expertAssign),
      }),
      (error) => ({ error }),
    );
    return {
      get: () => getMethod('get'),
      refresh: () =>  getMethod('post'),
    };
  }
}
